import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const ActivitiesActionTypes = {
  FETCH_ACTIVITIES: createSubtypes('activities|fetchActivities'),
  UPDATE_ACTIVITY_PHOTO_ALBUM_LINK: createSubtypes('activities|updatePhotoAlbumLink'),
  REMOVE_ACTIVITIES: 'activities|removeActivities',
  FETCH_ACTIVITY_DETAILS_DATA: createSubtypes('activities|fetchActivityDetailsData'),
  FETCH_ORDERS_HISTORY_DATA: createSubtypes('activities|fetchOrdersHistoryData'),
  FETCH_AVAILABLE_INSTALL_DATES: createSubtypes('activities|fetchAvailableInstallDates'),
  FETCH_AVAILABLE_DELIVERY_DATES: createSubtypes('activities|fetchAvailableDeliveryDates'),
  SAVE_DETAILS_TARGET_ACTIVITY: 'activities|saveDetailsTargetActivity',
  UPDATE_DETAILS_TARGET_OPPORTUNITY: 'activities|updateDetailsTargetOpportunity',
  UPDATE_TARGET_ACTIVITY: 'activities|updateTargetActivity',
  SAVE_CREATED_BUCKET_NAME: 'activities|saveCreatedBucketName',
  FETCH_TASK_CARD_STATUSES: createSubtypes('activities|fetchTaskCardStatuses'),
  UPDATE_ALBUM_LINK: createSubtypes('activities|updateAlbumLink'),
  SELECT_PROPOSAL: 'activities|selectProposal',
  REFRESH_ACTIVITIES: 'activities|refresh',
};
